import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFavorites } from '../../../hooks/useFavorites';
import { useUser } from '../../../contexts/UserContext';

import bookmark_L_OFF from '../../../assets/icons/svg/bookmark_L_OFF.svg';
import bookmark_L_ON from '../../../assets/icons/svg/bookmark_L_ON.svg';
import bookmark_M_OFF from '../../../assets/icons/svg/bookmark_M_OFF.svg';
import bookmark_M_ON from '../../../assets/icons/svg/bookmark_M_ON.svg';

// 즐겨찾기(찜) 상태를 토글하고 결과를 알림 모달로 안내하는 공통 버튼
function SaveButton({ size = 'M', name = '', className = '', id }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { isFavorite, addFavorite, removeFavorite } = useFavorites();
    const { user } = useUser();

    const handleSaveClick = async (e) => {
        e.stopPropagation();

        if (!user) {
            // 비로그인 상태면 로그인 페이지로 이동시키기 전에 경고 모달을 띄운다.
            const redirectUrl = location.pathname + location.search;
            alert({
                title: '로그인 필요합니다.',
                content: <p>찜한 여행은 로그인 후 우측 상단 탭, ‘찜한 여행’ 메뉴에서 확인이 가능합니다.</p>,
                confirmButtonText: '취소',
                footerContent: <button type="button" className="btn">로그인</button>,
                action: () => {
                navigate(`/login?redirect=${encodeURIComponent(redirectUrl)}`);
                },
            });
            return;
        }

        // 저장 결과 유무
        const isSaved = isFavorite(id);

        alert({
            // 모달 버튼은 추가/해제 여부에 따라 문구가 달라진다.
            title: isSaved ? '찜을 해제하시겠습니까?' : '찜을 추가하시겠습니까?',
            content: isSaved ? '찜을 해제하면 ‘찜한 여행’ 목록에서 해당 상품이 사라집니다.' : '찜을 추가하면 ‘찜한 여행’ 목록에서 해당 상품이 추가됩니다.',
            confirmButtonText: '취소',
            footerContent: <button type="button">{isSaved ? '해제하기' : '추가하기'}</button>,
            action: async () => {
                try {
                    if (isSaved) {
                        const result = await removeFavorite(id);
                        alert({
                            title: result.result === "success" ? '삭제 완료' : '에러',
                            content: result.result === "success" ? '찜한 여행에서 삭제되었습니다.' : result.message,
                            confirmButtonText: '확인',
                        });
                    } else {
                        const result = await addFavorite(id);
                        alert({
                            title: result.result === "success" ? '추가 완료' : '에러',
                            content: result.result === "success" ? '찜한 여행에 추가되었습니다.' : result.message,
                            confirmButtonText: '확인',
                        });
                    }
                } catch {
                    alert({
                        title: '에러',
                        content: '서버 에러가 발생했습니다.',
                        confirmButtonText: '닫기',
                    });
                }
            },
        });
    };

    // 아이콘 사이즈 정의
    const getIcon = () => {
        const isSaved = isFavorite(id);
        if (size === 'L') return isSaved ? bookmark_L_ON : bookmark_L_OFF;
        return isSaved ? bookmark_M_ON : bookmark_M_OFF;
    };

    return (
        <button
            type="button"
            className={`${className} common-save-btn save-btn-${size}`}
            onClick={handleSaveClick}
        >
            <img src={getIcon()} alt="저장하기" />
            {name && <span>{name}</span>}
        </button>
    );
}

export default SaveButton;
